mutation ClickTrackingDomainSet($input: ClickTrackingDomainSetInput!) {
    clickTrackingDomainSet(input: $input) {
        domainId
    }
}
